import { Injectable } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";

import { NoteBruger, NoteFormBuilder, NoteHenvendelsestype, NoteOmraade, NoteOpgavestyringStatus } from "@e-forsyning/common/note";

import { OpgaveNoterData } from "./model/opgave-noter-data.model";

@Injectable({ providedIn: "root" })
export class OpgaveNoteFormBuilder {
    public installationNoterDataToFormGroup(
        noter: OpgaveNoterData,
        omraader: NoteOmraade[],
        henvendelsestyper: NoteHenvendelsestype[],
        opgavestyringStatusser: NoteOpgavestyringStatus[],
        brugere: NoteBruger[]
    ): UntypedFormGroup {
        const result = new UntypedFormGroup({
            noter: NoteFormBuilder.noterToFormArray(noter.noter, omraader, henvendelsestyper, opgavestyringStatusser, brugere)
        });
        return result;
    }

    public formGroupToInstallationNoterData(formGroup: UntypedFormGroup): OpgaveNoterData {
        const formArray = formGroup.controls["noter"] as UntypedFormArray;
        const noter = NoteFormBuilder.formArrayToNoter(formArray);
        const result: OpgaveNoterData = {
            noter
        };
        return result;
    }
}
